import React from 'react';
import { createRoot } from 'react-dom/client'; // for some reason this is not working when creating project from a template
import { LibraryWrapper } from '@mgh-app/component-library';

import './index.scss';
import '@mgh-app/component-library/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find root element');
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <LibraryWrapper>
      <Provider store={store}>
        <App />
      </Provider>
    </LibraryWrapper>
  </React.StrictMode>,
);

defineCustomElements(window);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
